<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <table id="ni-regulatory-info-table">
      <thead>
        <tr>
          <th>Line No.</th>
          <th
            v-for="columnData in regulatoryInfoFields.regulatoryInfoColumns"
            :key="columnData.id"
            :class="columnData.className"
            :title="columnData.title"
          >
            <label>{{ columnData.label }}</label>
          </th>
        </tr>
      </thead>
      <tbody class="ni-app-regulatory-info-tbody">
        <tr
          v-for="(row, index) in regulatoryRows"
          :key="row.id"
          :class="[row.regltryQstnId ? 'row-' + row.regltryQstnId : 'newRow']"
          v-bind="row"
          @click="onRowClick($event)"
          @change="!isLoading ? changeRegOnRow($event, index, row) : ''"
        >
          <ValidationObserver>
            <td id="start" class="line-number">{{ row.lineNumber }}</td>
            <td style="display:none;">
              <b-input type="hidden" :value="row.regltryQstnId"></b-input>
            </td>
            <td class="line-errors">{{ row.lineErrors }}</td>
            <td>
              <b-input
                type="text"
                class="vcat"
                :value="row.vcat"
                disabled="disabled"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="desc"
                :value="row.desc30"
                disabled="disabled"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Chemicals,Consumables,Apparatus,Diagnostics,Furniture,TSCP,Instruments,Equipment"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="category"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="category"
                    v-model="row.category"
                    :value="
                      row.category === undefined
                        ? (row.category = ' ')
                        : row.category
                    "
                  >
                    <option value=" "></option>
                    <option value="Chemicals">
                      Chemicals
                    </option>
                    <option value="Consumables">
                      Consumables
                    </option>
                    <option value="Apparatus">
                      Apparatus
                    </option>
                    <option value="Diagnostics">
                      Diagnostics
                    </option>
                    <option value="Furniture">
                      Furniture
                    </option>
                    <option value="TSCP">
                      Training, Services, and Custom Products
                    </option>
                    <option value="Instruments">
                      Instruments
                    </option>
                    <option value="Equipment">
                      Equipment
                    </option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:99998,99999,00000"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="msds"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="msds"
                    v-model="row.msds"
                    :value="
                      row.msds === undefined ? (row.msds = ' ') : row.msds
                    "
                  >
                    <option value=" "></option>
                    <option value="99998">
                      99998
                    </option>
                    <option value="99999">
                      99999
                    </option>
                    <option value="00000">
                      00000
                    </option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <a
                v-if="
                  row.insertAttachName ||
                    row.batteryAttachmentName ||
                    isFileUploadedAttachment(row.msdsAttachmentName)
                "
                class="download-zip-icon"
                @click="downloadAttachment(row.regltryQstnId)"
              >
                <b-icon
                  icon="folder-zip"
                  title="Click to download"
                  class="download-zip-icon"
                  type="is-info"
                ></b-icon>
              </a>
              <a
                v-else
                class="download-zip-icon"
                title="No Files to Download"
              ></a>
            </td>
            <td>
              <p
                v-show="isFileUploadedAttachment(row.msdsAttachmentName)"
                class="msdsAttachment msdsAttachmentName has-text-info"
              >
                <span :title="row.msdsAttachmentName" class="attachment-title"
                  >{{ row.msdsAttachmentName }} </span
                >&nbsp;&nbsp;&nbsp;<b-upload
                  v-model="msdsAttachment"
                  @input="uploadAttachment('msdsAttachment', row.regltryQstnId)"
                  class="replace-attachment replace-msds-attachment"
                  ><a>
                    <b-icon
                      icon="file-replace"
                      type="is-info"
                      size="is-small"
                      title="Upload a new document to replace the existing one"
                    >
                    </b-icon></a
                ></b-upload>
              </p>
              <p
                v-show="
                  isFileUploadedAttachment(row.msdsAttachmentName) === false
                "
              >
                <b-field class="msds-hyperlink">
                  <a
                    @click="openLinkInNewWindow(row.msdsAttachmentName)"
                    class="open-link"
                    title="Open link in new window"
                    >{{ row.msdsAttachmentName }}</a
                  >
                </b-field>
              </p>
              <p v-show="row.msdsAttachmentName === undefined">
                <b-field v-if="isUser3PRITab" class="msds-type-wrapper">
                  <b-input
                    :value="row.msdsAttachmentName"
                    @change.native="
                      row.msdsAttachmentName = $event.target.value
                    "
                  ></b-input>
                  <b-upload
                    @input="
                      uploadAttachment('msdsAttachment', row.regltryQstnId)
                    "
                    class="msdsAttachment upload"
                    v-model="msdsAttachment"
                  >
                    <b-icon
                      class="file-icon"
                      type="is-info"
                      icon="upload"
                    ></b-icon>
                  </b-upload>
                </b-field>
                <b-field v-else class="msds-type-wrapper">
                  <ValidationProvider
                    rules="required_if:msds,99998,99999"
                    :bails="false"
                    v-slot="{ classes }"
                    immediate
                  >
                    <div class="control" :class="classes">
                      <b-input
                        :value="row.msdsAttachmentName"
                        @change.native="
                          row.msdsAttachmentName = $event.target.value
                        "
                      ></b-input></div
                  ></ValidationProvider>
                  <b-upload
                    @input="
                      uploadAttachment('msdsAttachment', row.regltryQstnId)
                    "
                    class="msdsAttachment upload"
                    v-model="msdsAttachment"
                  >
                    <b-icon
                      class="file-icon"
                      :type="
                        row.msds === '99998' || row.msds === '99999'
                          ? 'is-danger'
                          : 'is-info'
                      "
                      icon="upload"
                    ></b-icon>
                  </b-upload>
                </b-field>
              </p>
            </td>
            <td>
              <ValidationProvider
                :rules="{ oneOf: storageCodes }"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="storage"
                    v-model="row.storage"
                    :title="row.storage"
                    :value="
                      row.storage === undefined
                        ? (row.storage = ' ')
                        : row.storage
                    "
                    ><option value=" "></option>
                    <option
                      v-for="storageCode in storageCodes"
                      :value="storageCode"
                      :key="storageCode.id"
                    >
                      {{ storageCode }}
                    </option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PRITab"
                class="sterile"
                v-model="row.sterile"
                :value="
                  row.sterile === undefined ? (row.sterile = ' ') : row.sterile
                "
              >
                <option value=" "></option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="sterile"
                    v-model="row.sterile"
                    :value="
                      row.sterile === undefined
                        ? (row.sterile = ' ')
                        : row.sterile
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="prop65"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="prop65"
                    v-model="row.prop65"
                    :value="
                      row.prop65 === undefined ? (row.prop65 = ' ') : row.prop65
                    "
                    ><option value=" "> </option><option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:prop65,Y"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="prop65Haz"
                    v-model="row.prop65Haz"
                    :value="
                      row.prop65Haz === undefined
                        ? (row.prop65Haz = ' ')
                        : row.prop65Haz
                    "
                    :disabled="row.prop65 === 'N'"
                  >
                    <option value=" "></option>
                    <option value="Carcinogen Hazard">
                      Carcinogen Hazard
                    </option>
                    <option value="Reproductive Hazard">
                      Reproductive Hazard
                    </option>
                    <option value="Both">
                      Both
                    </option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'cancerChName'">
              <v-select
                :filterable="false"
                :options="cancerChNameOptions"
                class="cancerChName"
                v-model="row.cancerChName"
                :class="
                  (row.prop65Haz === 'Carcinogen Hazard' ||
                    row.prop65Haz === 'Both') &&
                  (row.cancerChName === undefined || row.cancerChName === '')
                    ? 'is-danger'
                    : ''
                "
                :disabled="
                  row.prop65 === ' ' ||
                    row.prop65 === 'N' ||
                    row.prop65Haz === '' ||
                    row.prop65Haz === 'Reproductive Hazard'
                "
                @input="changeRegOnRow($event, index, row)"
                @search="fetchCancerChName"
                :title="row.cancerChName"
              >
                <template slot="option" slot-scope="cancerChNameOption">
                  <div class="d-center">
                    {{ cancerChNameOption.label }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="cancerChNameOption"
                  title="cancerChNameOption"
                >
                  <div class="selected d-center">
                    {{ cancerChNameOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
            </td>
            <td v-on:keypress="typeAheadTriggered = 'repChName'">
              <v-select
                :filterable="false"
                :options="repChNameOptions"
                class="repChName"
                v-model="row.repChName"
                :class="
                  (row.prop65Haz === 'Reproductive Hazard' ||
                    row.prop65Haz === 'Both') &&
                  (row.repChName === undefined || row.repChName === '')
                    ? 'is-danger'
                    : ''
                "
                :disabled="
                  row.prop65 === ' ' ||
                    row.prop65 === 'N' ||
                    row.prop65Haz === '' ||
                    row.prop65Haz === 'Carcinogen Hazard'
                "
                @input="changeRegOnRow($event, index, row)"
                @search="fetchRepChName"
                :title="row.repChName"
              >
                <template slot="option" slot-scope="repChNameOption">
                  <div class="d-center">
                    {{ repChNameOption.label }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="repChNameOption"
                  title="repChNameOption"
                >
                  <div class="selected d-center">
                    {{ repChNameOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
            </td>
            <td>
              <div class="control">
                <b-select
                  :class="
                    row.prop65 === 'Y' &&
                    (row.prodLabel === undefined ||
                      row.prodLabel === '' ||
                      row.prodLabel === ' ')
                      ? 'is-danger'
                      : ''
                  "
                  class="prodLabel"
                  :disabled="row.prop65 === ' ' || row.prop65 === 'N'"
                  v-model="row.prodLabel"
                  :value="
                    row.prodLabel === undefined
                      ? (row.prodLabel = ' ')
                      : row.prodLabel
                  "
                  ><option value=" "></option><option value="Y">Yes</option
                  ><option value="N">No</option></b-select
                >
              </div>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="tsca6HPbt"
                    v-model="row.tsca6HPbt"
                    :value="
                      row.tsca6HPbt === undefined
                        ? (row.tsca6HPbt = ' ')
                        : row.tsca6HPbt
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="latex"
                    v-model="row.latex"
                    :value="
                      row.latex === undefined ? (row.latex = ' ') : row.latex
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="battery"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="battery"
                    v-model="row.battery"
                    :value="
                      row.battery === undefined
                        ? (row.battery = ' ')
                        : row.battery
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <p
                v-if="row.batteryAttachmentName"
                class="batteryAttachment has-text-info"
              >
                <span
                  :title="row.batteryAttachmentName"
                  class="attachment-title"
                  >{{ row.batteryAttachmentName }} </span
                >&nbsp;&nbsp;&nbsp;<b-upload
                  @input="
                    uploadAttachment('batteryAttachment', row.regltryQstnId)
                  "
                  v-model="batteryAttachment"
                  class="replace-attachment"
                  title="Replace Battery Attachment"
                  ><a>
                    <b-icon
                      icon="file-replace"
                      type="is-info"
                      size="is-small"
                      title="Replace Battery Attachment"
                    >
                    </b-icon></a
                ></b-upload>
              </p>
              <b-upload
                @input="
                  uploadAttachment('batteryAttachment', row.regltryQstnId)
                "
                class="batteryAttachment upload"
                v-model="batteryAttachment"
                v-else
              >
                <a class="button">
                  <span>Upload</span>
                </a>
              </b-upload>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:category,Consumables,Apparatus,Diagnostics,Furniture,TSCP,Instruments,Equipment"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="medDevice"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="medDevice"
                    v-model="row.medDevice"
                    :value="
                      row.medDevice === undefined
                        ? (row.medDevice = ' ')
                        : row.medDevice
                    "
                    ><option value=" "></option><option value="I">I</option
                    ><option value="II">II</option>
                    <option value="III">III</option>
                    <option value="None">None</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                v-if="isUser3PRITab"
                type="text"
                class="upcStd"
                :value="row.upcStd"
                @change.native="row.upcStd = $event.target.value"
              ></b-input>
              <ValidationProvider
                v-else-if="row.medDevice === 'None'"
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="upcStd"
                    :value="row.upcStd"
                    @change.native="row.upcStd = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="upcStd"
                :value="row.upcStd"
                @change.native="row.upcStd = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                v-if="isUser3PRITab"
                type="text"
                class="upcAlt"
                :value="row.upcAlt"
                @change.native="row.upcAlt = $event.target.value"
              ></b-input>
              <ValidationProvider
                v-else-if="
                  row.medDevice === 'None' &&
                    (row.au === 'DZ' || row.au === 'PK' || row.au === 'CS')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="upcAlt"
                    :value="row.upcAlt"
                    @change.native="row.upcAlt = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="upcAlt"
                :value="row.upcAlt"
                @change.native="row.upcAlt = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="row.caAvailability === 'Y'"
                rules="oneOf:1,2,3,4,NA"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="caMedDevice"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="caMedDevice"
                    v-model="row.caMedDevice"
                    :value="
                      row.caMedDevice === undefined
                        ? (row.caMedDevice = ' ')
                        : row.caMedDevice
                    "
                    ><option value=" "></option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="NA">NA</option>
                  </b-select>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                :bails="false"
                immediate
                vid="caMedDevice"
              >
                <b-select
                  class="caMedDevice"
                  v-model="row.caMedDevice"
                  :value="
                    row.caMedDevice === undefined
                      ? (row.caMedDevice = ' ')
                      : row.caMedDevice
                  "
                  ><option value=" "></option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="NA">NA</option>
                </b-select>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:caMedDevice,2,3,4"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="hcln"
                    oninput="if (this.value.length > 10)
                        this.value = this.value.slice(0, 10);"
                    v-model="row.caHealthLicense"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <p v-if="row.insertAttachName" class="insertAttach has-text-info">
                <span :title="row.insertAttachName" class="attachment-title"
                  >{{ row.insertAttachName }} </span
                >&nbsp;&nbsp;&nbsp;<b-upload
                  @input="uploadAttachment('insertAttach', row.regltryQstnId)"
                  v-model="insertAttach"
                  class="replace-attachment"
                  ><a
                    ><b-icon
                      icon="file-replace"
                      type="is-info"
                      size="is-small"
                      title="Replace Insert Attachment"
                    >
                    </b-icon
                  ></a>
                </b-upload>
              </p>
              <b-upload
                v-else
                @input="uploadAttachment('insertAttach', row.regltryQstnId)"
                class="insertAttach upload"
                v-model="insertAttach"
              >
                <a class="button">
                  <span>Upload</span>
                </a>
              </b-upload>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  row.medDevice === 'I' ||
                    row.medDevice === 'II' ||
                    row.medDevice === 'III'
                "
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="presMedDevice"
                    v-model="row.presMedDevice"
                    :value="
                      row.presMedDevice === undefined
                        ? (row.presMedDevice = ' ')
                        : row.presMedDevice
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
              <b-select
                v-else
                class="presMedDevice"
                v-model="row.presMedDevice"
                :value="
                  row.presMedDevice === undefined
                    ? (row.presMedDevice = ' ')
                    : row.presMedDevice
                "
                ><option value=" "></option><option value="Y">Yes</option
                ><option value="N">No</option></b-select
              >
            </td>
            <td>
              <ValidationProvider
                rules="required_if:medDevice,I,II,III"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="fda510kNum"
                    oninput="if (this.value.length > 10)
                        this.value = this.value.slice(0, 10);"
                    :value="row.fda510kNum"
                    @change.native="row.fda510kNum = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:medDevice,I,II,III"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="fdaProdCode"
                    oninput="if (this.value.length > 7)
                        this.value = this.value.slice(0, 7);"
                    :value="row.fdaProdCode"
                    @change.native="row.fdaProdCode = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (row.unitUse === 'EA' || row.su === 'EA') &&
                    (row.medDevice === 'I' ||
                      row.medDevice === 'II' ||
                      row.medDevice === 'III')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="gtinEa"
                    :value="row.gtinEa"
                    @change.native="row.gtinEa = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="gtinEa"
                :value="row.gtinEa"
                @change.native="row.gtinEa = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (row.su === 'PK' || row.au === 'PK') &&
                    (row.medDevice === 'I' ||
                      row.medDevice === 'II' ||
                      row.medDevice === 'III')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="gtinPk"
                    :value="row.gtinPk"
                    @change.native="row.gtinPk = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="gtinPk"
                :value="row.gtinPk"
                @change.native="row.gtinPk = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (row.su === 'CS' || row.au === 'CS') &&
                    (row.medDevice === 'I' ||
                      row.medDevice === 'II' ||
                      row.medDevice === 'III')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="gtinCs"
                    :value="row.gtinCs"
                    @change.native="row.gtinCs = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="gtinCs"
                :value="row.gtinCs"
                @change.native="row.gtinCs = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  row.medDevice === 'I' ||
                    row.medDevice === 'II' ||
                    row.medDevice === 'III'
                "
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="rxDrug"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="rxDrug"
                    v-model="row.rxDrug"
                    :value="
                      row.rxDrug === undefined ? (row.rxDrug = ' ') : row.rxDrug
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="rxDrug"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="rxDrug"
                    v-model="row.rxDrug"
                    :value="
                      row.rxDrug === undefined ? (row.rxDrug = ' ') : row.rxDrug
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  row.medDevice === 'I' ||
                    row.medDevice === 'II' ||
                    row.medDevice === 'III'
                "
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="overCounterDrug"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="overCounterDrug"
                    v-model="row.overCounterDrug"
                    :value="
                      row.overCounterDrug === undefined
                        ? (row.overCounterDrug = ' ')
                        : row.overCounterDrug
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="overCounterDrug"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="overCounterDrug"
                    v-model="row.overCounterDrug"
                    :value="
                      row.overCounterDrug === undefined
                        ? (row.overCounterDrug = ' ')
                        : row.overCounterDrug
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="row.rxDrug === 'Y' || row.overCounterDrug === 'Y'"
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 10)
                        this.value = this.value.slice(0, 10);"
                    class="ndc text-align-right"
                    :value="row.ndc"
                    @change.native="row.ndc = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 10)
                        this.value = this.value.slice(0, 10);"
                class="ndc text-align-right"
                :value="row.ndc"
                @change.native="row.ndc = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                v-if="isUser3PRITab"
                type="text"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 10)
                        this.value = this.value.slice(0, 10);"
                class="hts text-align-right"
                :value="row.hts"
                @change.native="row.hts = $event.target.value"
              ></b-input>
              <ValidationProvider
                v-else
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 10)
                        this.value = this.value.slice(0, 10);"
                    class="hts text-align-right"
                    :value="row.hts"
                    @change.native="row.hts = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PRITab"
                class="reach"
                v-model="row.reach"
                :value="row.reach === undefined ? (row.reach = ' ') : row.reach"
                ><option value=" "></option><option value="Y">Yes</option
                ><option value="N">No</option>
              </b-select>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="reach"
                    v-model="row.reach"
                    :value="
                      row.reach === undefined ? (row.reach = ' ') : row.reach
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-select
                v-if="isUser3PRITab"
                class="rohs"
                v-model="row.rohs"
                :value="row.rohs === undefined ? (row.rohs = ' ') : row.rohs"
                ><option value=" "></option><option value="Y">Yes</option
                ><option value="N">No</option></b-select
              >
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="rohs"
                    v-model="row.rohs"
                    :value="
                      row.rohs === undefined ? (row.rohs = ' ') : row.rohs
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="mercury"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="mercury"
                    v-model="row.mercury"
                    :value="
                      row.mercury === undefined
                        ? (row.mercury = ' ')
                        : row.mercury
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:mercury,Y"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="caMercuryMg"
                    :value="row.caMercuryMg"
                    @change.native="row.caMercuryMg = $event.target.value"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.split('.')[0].length > 3)  this.value = this.value.slice(0, 3);"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:category,Chemicals"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="benzene"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="benzene"
                    v-model="row.benzene"
                    :value="
                      row.benzene === undefined
                        ? (row.benzene = ' ')
                        : row.benzene
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:benzene,Y|max_value:100|min_value:0.0001"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                    class="benzenePct text-align-right"
                    :value="
                      row.benzenePct !== undefined
                        ? addFourZeros(row.benzenePct)
                        : row.benzenePct
                    "
                    @change.native="row.benzenePct = $event.target.value"
                  />
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="asbestos"
                    v-model="row.asbestos"
                    :value="
                      row.asbestos === undefined
                        ? (row.asbestos = ' ')
                        : row.asbestos
                    "
                    ><option value=" "></option> <option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="iodine"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="iodine"
                    v-model="row.iodine"
                    :value="
                      row.iodine === undefined ? (row.iodine = ' ') : row.iodine
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:iodine,Y|max_value:100|min_value:0.0001"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                    class="iodinePct text-align-right"
                    :value="
                      row.iodinePct !== undefined
                        ? addFourZeros(row.iodinePct)
                        : row.iodinePct
                    "
                    @change.native="row.iodinePct = $event.target.value"
                  />
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="radioActive"
                    v-model="row.radioActive"
                    :value="
                      row.radioActive === undefined
                        ? (row.radioActive = ' ')
                        : row.radioActive
                    "
                    ><option value=" "></option> <option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="pesticide"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="pesticide"
                    v-model="row.pesticide"
                    :value="
                      row.pesticide === undefined
                        ? (row.pesticide = ' ')
                        : row.pesticide
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:pesticide,Y"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="epaRegNum"
                    oninput="if (this.value.length > 12)
                        this.value = this.value.slice(0, 12);"
                    :value="row.epaRegNum"
                    @change.native="row.epaRegNum = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:pesticide,Y"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="caPestRNo"
                    v-model="row.calPestNum"
                    :value="
                      row.calPestNum === undefined
                        ? (row.calPestNum = ' ')
                        : row.calPestNum
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="alcohol"
                    v-model="row.alcohol"
                    :value="
                      row.alcohol === undefined
                        ? (row.alcohol = ' ')
                        : row.alcohol
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="isUser3PRITab"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ao"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ao"
                    v-model="row.ao"
                    :value="row.ao === undefined ? (row.ao = ' ') : row.ao"
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ao"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ao"
                    v-model="row.ao"
                    :value="row.ao === undefined ? (row.ao = ' ') : row.ao"
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ao,Y"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    class="aoType"
                    v-model="row.aoType"
                    :value="
                      row.aoType === undefined ? (row.aoType = ' ') : row.aoType
                    "
                  >
                  </b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                type="text"
                class="hyperlinkToItem"
                :value="row.hyperlinkToItem"
                @change.native="row.hyperlinkToItem = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="row.category === 'Chemicals'"
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="mdl"
                    :value="row.mdl"
                    @change.native="row.mdl = $event.target.value"
                    oninput="if (this.value.length > 12)
                        this.value = this.value.slice(0, 12);"
                  >
                  </b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="mdl"
                :value="row.mdl"
                @change.native="row.mdl = $event.target.value"
                oninput="if (this.value.length > 12)
                        this.value = this.value.slice(0, 12);"
              >
              </b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (row.category === 'Chemicals' && row.prop65 === 'Y') ||
                    row.category === 'Chemicals'
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="cas1No"
                    :value="row.cas1No"
                    @change.native="row.cas1No = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="cas1No"
                :value="row.cas1No"
                @change.native="row.cas1No = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  (row.category === 'Chemicals' && row.prop65 === 'Y') ||
                    row.category === 'Chemicals'
                "
                rules="required|max_value:100|min_value:0.0001"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="cas1Pt text-align-right"
                    oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                    :value="
                      row.cas1Pt !== undefined
                        ? addFourZeros(row.cas1Pt)
                        : row.cas1Pt
                    "
                    @change.native="row.cas1Pt = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                rules="max_value:100|min_value:0.0001"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="cas1Pt text-align-right"
                    oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                    :value="
                      row.cas1Pt !== undefined
                        ? addFourZeros(row.cas1Pt)
                        : row.cas1Pt
                    "
                    @change.native="row.cas1Pt = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                type="text"
                class="cas2No"
                :value="row.cas2No"
                @change.native="row.cas2No = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="cas2Pt text-align-right"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                :value="
                  row.cas2Pt !== undefined
                    ? addFourZeros(row.cas2Pt)
                    : row.cas2Pt
                "
                @change.native="row.cas2Pt = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="cas3No"
                :value="row.cas3No"
                @change.native="row.cas3No = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="cas3Pt text-align-right"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                :value="
                  row.cas3Pt !== undefined
                    ? addFourZeros(row.cas3Pt)
                    : row.cas3Pt
                "
                @change.native="row.cas3Pt = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="cas4No"
                :value="row.cas4No"
                @change.native="row.cas4No = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="cas4Pt text-align-right"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                :value="
                  row.cas4Pt !== undefined
                    ? addFourZeros(row.cas4Pt)
                    : row.cas4Pt
                "
                @change.native="row.cas4Pt = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="cas5No"
                :value="row.cas5No"
                @change.native="row.cas5No = $event.target.value"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="cas5Pt text-align-right"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                :value="
                  row.cas5Pt !== undefined
                    ? addFourZeros(row.cas5Pt)
                    : row.cas5Pt
                "
                @change.native="row.cas5Pt = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="row.category === 'Chemicals'"
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="deaList1"
                    v-model="row.deaList1"
                    :value="
                      row.deaList1 === undefined
                        ? (row.deaList1 = ' ')
                        : row.deaList1
                    "
                    ><option value=" "></option><option value="Y">Yes</option
                    ><option value="N">No</option></b-select
                  >
                </div>
              </ValidationProvider>
              <b-select
                v-else
                class="deaList1"
                v-model="row.deaList1"
                :value="
                  row.deaList1 === undefined
                    ? (row.deaList1 = ' ')
                    : row.deaList1
                "
                ><option value=" "></option><option value="Y">Yes</option
                ><option value="N">No</option></b-select
              >
            </td>
            <td>
              <ValidationProvider
                v-if="row.caAvailability === 'Y'"
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="caHydro"
                    :value="row.caHydro"
                    @change.native="row.caHydro = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="caHydro"
                :value="row.caHydro"
                @change.native="row.caHydro = $event.target.value"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                v-if="row.caAvailability === 'Y'"
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    type="text"
                    class="caWhims"
                    v-model="row.caWhmis"
                    :value="
                      row.caWhmis === undefined
                        ? (row.caWhmis = ' ')
                        : row.caWhmis
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes </option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
              <b-select
                v-else
                class="caWhims"
                v-model="row.caWhmis"
                :value="
                  row.caWhmis === undefined ? (row.caWhmis = ' ') : row.caWhmis
                "
              >
                <option value=" "></option>
                <option value="Y">Yes </option>
                <option value="N">No</option>
              </b-select>
            </td>
            <td>
              <ValidationProvider
                v-if="row.caAvailability === 'Y'"
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    type="text"
                    class="caMarine"
                    v-model="row.caMarine"
                    :value="
                      row.caMarine === undefined
                        ? (row.caMarine = ' ')
                        : row.caMarine
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes </option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
              <b-select
                v-else
                class="caMarine"
                v-model="row.caMarine"
                :value="
                  row.caMarine === undefined
                    ? (row.caMarine = ' ')
                    : row.caMarine
                "
              >
                <option value=" "></option>
                <option value="Y">Yes </option>
                <option value="N">No</option>
              </b-select>
            </td>
            <td>
              <ValidationProvider
                v-if="row.caAvailability === 'Y'"
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="naftaCert"
                    v-model="row.caNafta"
                    :value="
                      row.caNafta === undefined
                        ? (row.caNafta = ' ')
                        : row.caNafta
                    "
                  >
                    <option value=" "></option>
                    <option value="Y">Yes </option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
              <b-select
                v-else
                class="naftaCert"
                v-model="row.caNafta"
                :value="
                  row.caNafta === undefined ? (row.caNafta = ' ') : row.caNafta
                "
              >
                <option value=" "></option>
                <option value="Y">Yes </option>
                <option value="N">No</option>
              </b-select>
            </td>
            <td>
              <ValidationProvider
                v-if="row.caAvailability === 'Y'"
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    class="caRegulation"
                    :value="row.caRegulation"
                    @change.native="row.caRegulation = $event.target.value"
                  ></b-input>
                </div>
              </ValidationProvider>
              <b-input
                v-else
                type="text"
                class="caRegulation"
                :value="row.caRegulation"
                @change.native="row.caRegulation = $event.target.value"
              ></b-input>
            </td>
            <!--<td>
              <ValidationProvider
                rules="oneOf:Y,N"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="tscaChemicals"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="tscaChemicals"
                    v-model="row.tscaChemicals"
                    :value="
                      row.tscaChemicals === undefined
                        ? (row.tscaChemicals = ' ')
                        : row.tscaChemicals
                    "
                    ><option value=" "> </option><option value="Y">Yes</option>
                    <option value="N">No</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:tscaChemicals,Y"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    class="caRegulation"
                    v-model="row.tscaChemicalsType"
                    :value="
                      row.tscaChemicalsType === undefined
                        ? (row.tscaChemicalsType = ' ')
                        : row.tscaChemicalsType
                    "
                  >
                    <option value=" "></option>
                    <option value="Hexachlorobutadiene">
                      Hexachlorobutadiene
                    </option>
                    <option value="2,4,6-Tris(tert-butyl)phenol">
                      2,4,6-Tris(tert-butyl)phenol
                    </option>
                    <option value="Decabromodiphenyl ether">
                      Decabromodiphenyl ether
                    </option>
                    <option value="Pentachlorothiophenol">
                      Pentachlorothiophenol
                    </option>
                    <option value="Phenol, isopropylated, phosphate (3:1)">
                      Phenol, isopropylated, phosphate (3:1)
                    </option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>-->
          </ValidationObserver>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import BUpload from "buefy/src/components/upload/Upload";
import BIcon from "buefy/src/components/icon/Icon";
import BInput from "buefy/src/components/input/Input";
import vSelect from "vue-select";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: [" ", "", null, undefined, 0].indexOf(value) === -1
    };
  },
  computesRequired: true
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

export default {
  name: "RegulatoryInformationTabComponent.vue",
  components: { BInput, BIcon, BUpload, vSelect },
  data() {
    return {
      isLoading: false,
      isUser3PRITab: false,
      rowIds: [],
      regulatoryRows: [],
      generalQuestionRows: [],
      actions: [],
      paginationParams: [],
      storageCodes: [],
      cancerChNameOptions: [],
      repChNameOptions: [],
      regulatoryInfoFields: {
        regulatoryInfoColumns: [
          {
            className: "",
            field: "lineErrors",
            label: "Line Errors",
            title: ""
          },
          {
            className: "",
            field: "vcat",
            label: "Supplier Catalog Number",
            title: ""
          },
          {
            className: "",
            field: "desc",
            label: "Item Description - 30 Characters",
            title: ""
          },
          {
            className: "",
            field: "category",
            label: "Primary Commodity Code",
            title: "What type of prodct is this?"
          },
          {
            className: "",
            field: "msds",
            label: "Safety Data Sheet Code",
            title:
              "Select SDS enclosed from supplier in package (99998), SDS is responsibility of Fisher (99999), or No SDS is required (00000)"
          },
          {
            className: "",
            field: "",
            label: "Download Attachments",
            title: ""
          },
          {
            className: "",
            field: "",
            label: "Attach SDS",
            title:
              "Select MSDS enclosed from supplier in package (99998), MSDS is responsibility of Fisher Scientific (99999), or No MSDS is required (00000). Enter hyperlink or attach SDS in UI"
          },
          {
            className: "",
            field: "storage",
            label: "Storage Code",
            title:
              "Based on time and temperature codes. GWN4 if no special storage necessary."
          },
          {
            className: "",
            field: "sterile",
            label: "Sterile",
            title: "Is the product sterile?"
          },
          {
            className: "",
            field: "prop65",
            label: "Proposition 65",
            title:
              "Does this product contain a California Proposition 65 chemical?"
          },
          {
            className: "",
            field: "prop65Haz",
            label: "Proposition 65 Detail",
            title:
              "Is the California Proposition 65 chemical a Carcinogen or Reproductive Hazard or both?"
          },
          {
            className: "",
            field: "cancerChName",
            label: "Carcinogen Chemical Name",
            title:
              "Required if Proposition 65 is Yes and Proposition 65 Detail is Carcinogen Hazard or Both."
          },
          {
            className: "",
            field: "repChName",
            label: "Reproductive Chemical Name",
            title:
              "Required if Proposition 65 is Yes and Proposition 65 Detail is Reproductive Hazard or Both."
          },
          {
            className: "",
            field: "prodLabel",
            label: "Prop 65 Product Labeling",
            title:
              "Select Yes(Y)/No(N) if Proposition 65 Detail is either Carcinogen Hazard or Reproductive Hazard or Both."
          },
          {
            className: "",
            field: "tsca6HPbt",
            label: "TSCA 6H PBT",
            title:
              "Select yes(Y) or no(N) whether the product contains TSCA 6H PBT.\nHexachlorobutadiene(HCBD)[87-68-3], 2,4,6-Tris(tert-butyl)(2,4,6-TTBP)phenol [732-26-3], Decabromodiphenyl ether(DecaBDE)[1163-19-5], Pentachlorothiophenol(PCTP)[133-49-3], Phenol, isopropylated, phosphate (3:1)PIP (PIP)[68937-41-7]"
          },
          {
            className: "",
            field: "latex",
            label: "Latex",
            title: "Select yes(Y) or no(N) whether the product contains latex"
          },
          {
            className: "",
            field: "battery",
            label: "Lithium Battery",
            title: "Does the product contain a lithium battery?"
          },
          {
            className: "",
            field: "",
            label: "Lithium Battery Test Summary Report",
            title: "Attach Lithium Battery Test Summary Report"
          },
          {
            className: "",
            field: "medDevice",
            label: "Medical Device",
            title:
              "Is this product considered a medical device, Class I, II or III?"
          },
          {
            className: "",
            field: "upcStd",
            label: "UPC - Standard",
            title: "Universal Product Code for standard unit"
          },
          {
            className: "",
            field: "upcAlt",
            label: "UPC - Alternate",
            title: "Universal Product Code for alternate unit"
          },
          {
            className: "",
            field: "caMedDevice",
            label: "Canadian Medical Device Class",
            title:
              "If product is a medical device, please indicate class (1, 2, 3 or 4). If class 2, 3 or 4, please indicate Health Canada license #.\n" +
              "Note: Canadian classification can differ from US classification."
          },
          {
            className: "",
            field: "caHealthLicense",
            label: "Health Canada License #",
            title: ""
          },
          {
            className: "",
            field: "insertAttachmane",
            label: "Medical Device Insert/Attachment",
            title: "Insert or instructions attached"
          },
          {
            className: "",
            field: "presMedDevice",
            label: "Prescription Medical Device",
            title: "Is this a prescription medical device?"
          },
          {
            className: "",
            field: "fda510kNum",
            label: "FDA 510k number",
            title: "What is the FDA 510(K) premarket submission number?"
          },
          {
            className: "",
            field: "fdaProdCode",
            label: "FDA product code",
            title: "Product code assigned by the FDA"
          },
          {
            className: "",
            field: "",
            label: "GTIN - EA",
            title: "Global Trade Item Number for Each"
          },
          {
            className: "",
            field: "",
            label: "GTIN - Pack",
            title: "Global Trade Item Number for Pack"
          },
          {
            className: "",
            field: "",
            label: "GTIN - Case",
            title: "Global Trade Item Number for Case"
          },
          {
            className: "",
            field: "rxDrug",
            label: "Prescription Drug",
            title: "Is product is a prescription drug?"
          },
          {
            className: "",
            field: "overCounterDrug",
            label: "Over the Counter Drug",
            title: "Is this over the counter drug?"
          },
          {
            className: "",
            field: "ndc",
            label: "National Drug Code",
            title: "Universal product identifier for human drugs"
          },
          {
            className: "",
            field: "hts",
            label: "Harmonized Tariff Schedule Code",
            title:
              "For number, see  http://www.usitc.gov/tata/hts/bychapter/index.htm"
          },
          {
            className: "",
            field: "reach",
            label: "REACH Compliant",
            title:
              "Is this product complaint with REACH?   Y/N\n" +
              "If N, Does it contain any of the SVHC’s over the threshold ?\n" +
              "If Y, please check or list chemical and %\n"
          },
          {
            className: "",
            field: "rohs",
            label: "RoHS Compliant",
            title:
              "Is this product RoHS compliant? exempt? Out of Scope?\n" +
              "Which RoHS substance does it contain?\n"
          },
          {
            className: "",
            field: "mercury",
            label: "Mercury",
            title: "Does this product contain mercury?"
          },
          {
            className: "",
            field: "caMercuryMg",
            label: "Milligrams of Mercury",
            title:
              "For parts available in Canada - How many milligrams of Mercury are in the product?"
          },
          {
            className: "",
            field: "benzene",
            label: "Benzene",
            title: "Does this product contain benzene?"
          },
          {
            className: "",
            field: "benzenePct",
            label: "Benzene %",
            title: "What percentage of benzene does this product contain?"
          },
          {
            className: "",
            field: "asbestos",
            label: "Asbestos",
            title: "Does this product contain asbestos?"
          },
          {
            className: "",
            field: "iodine",
            label: "Iodine",
            title: "Does this product contain iodine?"
          },
          {
            className: "",
            field: "iodinePct",
            label: "Iodine %",
            title: "What percentage of iodine does this product contain?"
          },
          {
            className: "",
            field: "radioActive",
            label: "Radioactive Materials",
            title: "Does this product contain radioactive materials?"
          },
          {
            className: "",
            field: "pesticide",
            label: "Pesticides",
            title: "Does this product contain pesticides?"
          },
          {
            className: "",
            field: "epaRegNum",
            label: "EPA Registration Number",
            title:
              "If the EPA (FIFRA) registration cannot be obtained, a copy of the product label which should contain this number"
          },
          {
            className: "",
            field: "calPestNum",
            label: "CA Dept. of Pesticides Regulation Number",
            title:
              "Does this product have a California Department of Pesticides regulation number?"
          },
          {
            className: "",
            field: "alcohol",
            label: "Ethyl Alcohol",
            title: "Does this product contain ethyl alcohol?"
          },
          {
            className: "",
            field: "ao",
            label: "Animal or Human Origin",
            title:
              "Has the item been sourced from animal or human? Yes or no required."
          },
          {
            className: "",
            field: "aoType",
            label: "Animal or Human Origin Types",
            title:
              "If YES to column AO, specific type is required. (i.e. bovine, porcine, mouse, human)"
          },
          {
            className: "",
            field: "",
            label: "Supplier Website Item Link",
            title:
              "Please provide a hyperlink from the Supplier website to the item"
          },
          {
            className: "",
            field: "mdl",
            label: "MDL Number",
            title: "What is the MDL Number?"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Number (CAS 1)",
            title:
              "The Chemical Abstract Number (CAS) is used to track and report levels of selected substances stored or sold from a given location"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Percentage(1)",
            title: "Percentage of Chemical Abstract Number(1) in the product"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Number (CAS 2)",
            title:
              "The Chemical Abstract Number (CAS) is used to track and report levels of selected substances stored or sold from a given location"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Percentage(2)",
            title: "Percentage of Chemical Abstract Number(2) in the product"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Number (CAS 3)",
            title:
              "The Chemical Abstract Number (CAS) is used to track and report levels of selected substances stored or sold from a given location"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Percentage(3)",
            title: "Percentage of Chemical Abstract Number(3) in the product"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Number (CAS 4)",
            title:
              "The Chemical Abstract Number (CAS) is used to track and report levels of selected substances stored or sold from a given location"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Percentage(4)",
            title: "Percentage of Chemical Abstract Number(4) in the product"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Number (CAS 5)",
            title:
              "The Chemical Abstract Number (CAS) is used to track and report levels of selected substances stored or sold from a given location\n"
          },
          {
            className: "",
            field: "",
            label: "Chemical Abstracts Percentage(5)",
            title: "Percentage of Chemical Abstract Number(5) in the product\n"
          },
          {
            className: " width-275",
            field: "",
            label: "DEA List I or Scheduled I-V drug",
            title:
              "Is this item a DEA List 1 chemical and/or DEA Drug (scheduled or controlled substance)\n"
          },
          {
            className: "",
            field: "",
            label: "Hydro",
            title:
              'For parts available in Canada - If equipment plugs into wall, indicate Canadian electrical approval mark (eg. CS, cUL, cETL). Note: This mark must be visible on the plate of the instrument. If electrical and does not have Canadian approval, indicate "not certified". Uncertified units can be certified in our warehouse for a small charge - but if uncertified unit is shipped to the customer, it can be very costly to certify in the field to rectify the situation. Selling uncertified units exposes us to liability in cases of electrical shock or fire.\n'
          },
          {
            className: "",
            field: "caWhmis",
            label: "WHMIS Regulated? (Y/N)",
            title:
              "For parts available in Canada - Is this a hazardous product that is regulated under GHS/WHMIS 2015?"
          },
          {
            className: "",
            field: "caMarine",
            label: "Marine Pollutant",
            title:
              "For parts available in Canada - Is this substance considered a Marine Pollutant under IMDG (International Maritime Dangerous Goods) code? (info usually available on SDS sheet) \n"
          },
          {
            className: "",
            field: "caNafta",
            label: "Is USMCA/CUSMA Certificate available?",
            title:
              "For parts available in Canada - Does the item qualify for Canada/US/Mexico Agreement? (previously NAFTA)"
          },
          {
            className: "",
            field: "caRegulation",
            label: "Federal or Int'l Regulations",
            title:
              "For parts available in Canada - Can include chemicals regulated by DEA/Health Canada, Drug Precursors, Chemical Weapons, Environmentally Regulated chemicals (such as Prohibited Toxic Substances), Explosives, products regulated under ITAR (International Traffic in Arms Regulations), REACH regulated chemicals, Over the Counter drugs or Natural Health products (please include Health Canada Drug Identification Number or Natural Product Number), safety products that are restricted to first responders (Controlled Goods Program), etc.  Please note which regulation is applicable, if any."
          }
          /*{
            className: "",
            field: "tscaChemicals",
            label: "TSCA Chemicals",
            title: "Is the product TSCA Chemical?"
          },
          {
            className: "",
            field: "tscaChemicalsType",
            label: "TSCA ChemicalsType",
            title: "What type of TSCA Chemical?"
          }*/
        ]
      },
      typeAheadTriggered: "",
      msdsAttachment: null,
      insertAttach: null,
      batteryAttachment: null,
      loginRole: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").roleKey
        : ""
    };
  },
  props: [
    "submissionIdForRegulatoryInformation",
    "loadRegulatoryInformationData"
  ],
  watch: {
    loadRegulatoryInformationData(value) {
      if (value.loadDetails) {
        this.generalQuestionRows = value.generalQuestionRows;
        this.actions = value.actions;
        this.paginationParams = value.paginationParams;
        this.loadItemRegDetailsUnderSubmission();
      }
    }
  },
  mounted() {
    if (sessionStorage.getItem("se_ni_user")) {
      this.loadStorageCodes();
    }
  },
  methods: {
    onRowClick: function(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    addTwoZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 2)
      );
    },
    addFourZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 4)
      );
    },
    fetchCancerChName(search, loading) {
      this.typeAheadTriggered = "cancerChName";
      this.fetchTypeAhead(search, loading);
    },
    fetchRepChName(search, loading) {
      this.typeAheadTriggered = "repChName";
      this.fetchTypeAhead(search, loading);
    },
    fetchTypeAhead(search, loading) {
      if (search.length > 0) {
        var scope = this;
        var field = "";

        loading(true);
        scope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}getChemCategoryNames/chemical`,
            { name: search }
          )
          .then(function(response) {
            loading(false);
            switch (scope.typeAheadTriggered) {
              case "cancerChName":
                scope.cancerChNameOptions = response.data;
                break;
              case "repChName":
                scope.repChNameOptions = response.data;
                break;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            scope.$buefy.dialog.alert({
              message: `Failed to load matching results. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    loadStorageCodes() {
      var regulatoryInformationScope = this;
      regulatoryInformationScope.loading = true;
      regulatoryInformationScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}regltryInfo/loadStorageCodes`
        )
        .then(function(response) {
          regulatoryInformationScope.loading = false;
          regulatoryInformationScope.storageCodes = response.data;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          regulatoryInformationScope.loading = false;
          regulatoryInformationScope.$buefy.dialog.alert({
            message: `Failed to load storage codes. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    loadItemRegDetailsUnderSubmission() {
      var regulatoryInformationScope = this;
      regulatoryInformationScope.isLoading = true;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (
        this.actions.fErrors ||
        this.actions.fCategory ||
        this.actions.fProp65 ||
        this.actions.fMedDevice
      ) {
        requestPayload.actions.push("Filter");
        requestPayload.filterMap = {};
        if (this.actions.fErrors) {
          requestPayload.filterMap.ErroredItems = this.actions.fErrors;
        }
        if (this.actions.fCategory) {
          requestPayload.filterMap.category = this.actions.fCategory;
        }
        if (this.actions.fProp65) {
          requestPayload.filterMap.prop65 = this.actions.fProp65;
        }
        if (this.actions.fMedDevice) {
          requestPayload.filterMap.medDevice = this.actions.fMedDevice;
        }
      }
      if (this.actions.soField && this.actions.soOrder) {
        requestPayload.actions.push("Sort");
        requestPayload.sortMap = {};
        requestPayload.sortMap[this.actions.soField] = this.actions.soOrder;
      }
      if (this.actions.srFieldName && this.actions.srValue) {
        requestPayload.actions.push("Search");
        requestPayload.searchMap = {};
        requestPayload.searchMap[
          this.actions.srFieldName
        ] = this.actions.srValue;
      }

      regulatoryInformationScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}regltryInfo/submissionId/${regulatoryInformationScope.submissionIdForRegulatoryInformation}?pageNbr=${regulatoryInformationScope.paginationParams.pageIndex}&pageSize=${regulatoryInformationScope.paginationParams.numberOfRegulatoryItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          var regulatoryPaginationParams = {
            startIndex: response.data.startIndex,
            endIndex: response.data.endIndex,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages
          };
          regulatoryInformationScope.$emit(
            "regulatoryPaginationParams",
            regulatoryPaginationParams
          );
          regulatoryInformationScope.$emit(
            "riTabErrorCount",
            response.data.errorCount
          );
          regulatoryInformationScope.isUser3PRITab = response.data.user3P;
          response.data.validateForm === "Y"
            ? regulatoryInformationScope.$emit("disableValidate", true)
            : regulatoryInformationScope.$emit("enableValidate", true);

          if (
            response.data.validateForm === "Y" &&
            response.data.errorCount === 0
          ) {
            regulatoryInformationScope.$emit(
              "disableCreatorSubmitFromRegulatory",
              true
            );
          } else {
            regulatoryInformationScope.$emit(
              "disableCreatorSubmitFromRegulatory",
              false
            );
          }
          //emit errorCount for super user when isSubmissionActiveForPS is true
          if (regulatoryInformationScope.loginRole === 6) {
            if (window.isSubmissionActiveForPS) {
              regulatoryInformationScope.$emit(
                "riTabSupplierTabsErrorCountForSuperUser",
                response.data.errorCount
              );
            }
          }

          regulatoryInformationScope.isLoading = false;
          regulatoryInformationScope.regulatoryRows = [];
          var mutableResponseRows = response.data.psfsNewItemRegltryQstnsTbs;
          if (requestPayload.actions.length > 0) {
            if (response.data.psfsNewItemRegltryQstnsTbs.length > 0) {
              for (
                var i = 0, lineNumber = regulatoryPaginationParams.startIndex;
                i < mutableResponseRows.length && lineNumber > 0;
                i++, lineNumber++
              ) {
                regulatoryInformationScope.rowIds.push(
                  mutableResponseRows[i].genlQstnId
                );
                mutableResponseRows[i].lineNumber = lineNumber;
              }
              regulatoryInformationScope.regulatoryRows = mutableResponseRows;
              sessionStorage.setItem(
                "regulatoryRows",
                JSON.stringify(response.data.psfsNewItemRegltryQstnsTbs)
              );
            } else {
              regulatoryInformationScope.regulatoryRows = [];
            }
          } else {
            if (response.data.psfsNewItemRegltryQstnsTbs.length > 0) {
              for (
                var j = 0, lineNumberJ = regulatoryPaginationParams.startIndex;
                j < mutableResponseRows.length && lineNumberJ > 0;
                j++, lineNumberJ++
              ) {
                regulatoryInformationScope.rowIds.push(
                  mutableResponseRows[j].genlQstnId
                );
                mutableResponseRows[j].lineNumber = lineNumberJ;
              }
              regulatoryInformationScope.regulatoryRows = mutableResponseRows;
              sessionStorage.setItem(
                "regulatoryRows",
                JSON.stringify(response.data.psfsNewItemRegltryQstnsTbs)
              );
            } else {
              regulatoryInformationScope.regulatoryRows = [];
              sessionStorage.removeItem("regulatoryRows");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          regulatoryInformationScope.isLoading = false;
          regulatoryInformationScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${regulatoryInformationScope.submissionIdForRegulatoryInformation}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          //focus on first editable category field
          if (!$(".ni-app-regulatory-info-tab").hasClass("viewOnly")) {
            $(".ni-app-regulatory-info-tbody")
              .children("tr")
              .first()
              .find("td:has(.category select)")
              .find("select")
              .focus();
          }

          //custom navigator plugin using jquery
          (function($) {
            $.fn.enableCellNavigation = function() {
              var arrow = {
                left: 37,
                up: 38,
                right: 39,
                down: 40
              };
              var esc = 27;

              // select all on focus
              // works for elements and will put focus into
              // adjacent input or select
              $(".ni-app-regulatory-info-tbody")
                .find("input,select,a")
                .keydown(function(e) {
                  // shortcut for key other than arrow keys
                  if (
                    $.inArray(e.which, [
                      arrow.left,
                      arrow.up,
                      arrow.right,
                      arrow.down,
                      esc
                    ]) < 0
                  ) {
                    return;
                  }

                  var input = e.target;
                  var td = $(e.target).closest("td");
                  var moveTo = null;

                  switch (e.which) {
                    case arrow.left: {
                      if (
                        ($(input).is("input:text") &&
                          input.selectionStart !== 0) === false
                      ) {
                        //left on category
                        if (td.index() === 5) {
                          moveTo = td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row):not(.lock-partial-row)")
                            .first("tr")
                            .find("td:has(.caRegulation input)");
                        }
                        //left on storage
                        else if (td.index() === 9) {
                          moveTo = td.prevAll("td:has(.msds select)");
                        }
                        //left on medDevice
                        else if (td.index() === 16) {
                          moveTo = td.prevAll("td:has(.battery select)");
                        }
                        //left on presMedDevice
                        else if (td.index() === 22) {
                          moveTo = td.prevAll("td:has(.hcln input)");
                        }
                        //left on input, select
                        //skip disabled fields
                        else {
                          moveTo = td.prev(
                            "td:has(input:not(:disabled):not(:file),select:not(:disabled),a:not(:disabled))"
                          );
                        }
                      }
                      break;
                    }
                    case arrow.right: {
                      if (
                        ($(input).is("input:text") &&
                          input.selectionStart !== input.value.length) === false
                      ) {
                        if (td.index() === 6) {
                          moveTo = td.nextAll("td:has(.storage select)");
                        } else if (td.index() === 14) {
                          moveTo = td.nextAll("td:has(.medDevice select)");
                        } else if (td.index() === 20) {
                          moveTo = td.nextAll("td:has(.presMedDevice select)");
                        } else {
                          moveTo = td.next("td:has(input,select,a)");
                          if (moveTo.length === 0) {
                            moveTo = td
                              .parents("tr")
                              .next("tr")
                              .find("td:has(.category select)");
                          }
                        }
                      }
                      break;
                    }

                    case arrow.up:
                    case arrow.down: {
                      e.preventDefault();
                      var tr = td.closest("tr");
                      var pos = td.index();

                      var moveToRow = null;
                      if (e.which == arrow.down) {
                        moveToRow = tr.next("tr");
                      } else if (e.which == arrow.up) {
                        moveToRow = tr.prev("tr");
                      }

                      if (moveToRow.length) {
                        moveTo = $(moveToRow[0].children[0].children[pos]);
                      }

                      break;
                    }
                    case esc:
                      if (e.target.localName === "select") {
                        console.log("esc clicked on select");
                      }
                      break;
                  }

                  if (moveTo && moveTo.length) {
                    e.preventDefault();
                    var input = $(moveTo[0]).find("input")[0];
                    if (arrow.right === e.which && $(input).is("input:text")) {
                      // var input = $(moveTo[0]).find("input")[0];
                      input.focus();
                      $(input)
                        .get(0)
                        .setSelectionRange(0, 0);
                    } else if (
                      arrow.left === e.which &&
                      $(input).is("input:text")
                    ) {
                      // var input = $(moveTo[0]).find("input")[0];
                      if (typeof input.selectionStart == "number") {
                        input.selectionStart = input.selectionEnd =
                          input.value.length;
                      } else if (typeof input.createTextRange != "undefined") {
                        var range = input.createTextRange();
                        range.collapse(false);
                        range.select();
                      }
                      input.focus();
                    } else if ($(input).is("input:text")) {
                      // var input = $(moveTo[0]).find("input")[0];
                      input.focus();
                    } else {
                      //focus on input, select
                      var input = $(moveTo[0]).find("input,select")[0];
                      input.focus();
                    }
                  }
                });
            };
          })($);

          // use the plugin
          $(function() {
            $("#ni-regulatory-info-table").enableCellNavigation();
          });
        });
    },
    changeRegOnRow(event, index, rowData) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("regulatoryRows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("regulatoryRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsNewItemRegltryErrTbs" &&
            key !== "batteryAttachmentName" &&
            key !== "insertAttachName" &&
            key !== "vcat" &&
            key !== "desc30" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              this.updateItemReg(rowData, index);
              break;
            }
          }
        }
      }
    },
    updateItemReg(requestPayload, index) {
      var regulatoryInformationScope = this;
      var param = {};
      param.noOfRows = 1;
      param.action = "";
      param.vcat = requestPayload.vcat;
      param.desc = "";
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      if (sessionStorage.getItem("se_ni_user")) {
        requestPayload.createdBy = JSON.parse(
          sessionStorage.getItem("se_ni_user")
        ).networkId;
      } else {
        requestPayload.createdBy = window.$cookies.get("ni_key").networkId;
      }

      var updatedRowData = {};

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if (prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      regulatoryInformationScope.isLoading = true;
      regulatoryInformationScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}submissionId/${regulatoryInformationScope.submissionIdForRegulatoryInformation}/modifyRegulatoryQstns?noOfRows=${param.noOfRows}&action=${param.action}&vcat=${param.vcat}&desc=${param.desc}`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          regulatoryInformationScope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber =
            regulatoryInformationScope.regulatoryRows[index].lineNumber;
          regulatoryInformationScope.regulatoryRows[index] = apiRow;
          var riRows = JSON.parse(sessionStorage.getItem("regulatoryRows"));
          riRows.splice(index, 1, response.data);
          sessionStorage.setItem("regulatoryRows", JSON.stringify(riRows));
          //enable/disable creator submit button
          response.data.validateForm === "Y"
            ? regulatoryInformationScope.$emit("disableValidate", true)
            : regulatoryInformationScope.$emit("enableValidate", true);

          if (
            response.data.validateForm === "Y" &&
            response.data.errorCount === 0
          ) {
            regulatoryInformationScope.$emit(
              "disableCreatorSubmitFromRegulatory",

              true
            );
          } else {
            regulatoryInformationScope.$emit(
              "disableCreatorSubmitFromRegulatory",
              false
            );
          }
          regulatoryInformationScope.$emit(
            "riTabErrorCount",
            response.data.errorCount
          );
          //emit errorCount for super user when isSubmissionActiveForPS is true
          if (regulatoryInformationScope.loginRole === 6) {
            if (window.isSubmissionActiveForPS) {
              regulatoryInformationScope.$emit(
                "riTabSupplierTabsErrorCountForSuperUser",
                response.data.errorCount
              );
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          regulatoryInformationScope.isLoading = false;
          regulatoryInformationScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${regulatoryInformationScope.submissionIdForRegulatoryInformation}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(
            ".ni-app-regulatory-info-tbody"
          ).rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".ni-app-regulatory-info-tbody")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    },
    isFileUploadedAttachment(fileName) {
      return (
        fileName && /^.*\.(pdf|png|jpg|eps|tiff)$/.test(fileName.toLowerCase())
      );
    },
    openLinkInNewWindow(url) {
      if (!url.match(/^https?:\/\//i)) {
        url = "http://" + url;
      }
      window.open(url, "_blank", "toolbar=0,location=0,menubar=0");
    },
    uploadAttachment(attachmentName, regltryQstnId) {
      var regulatoryInformationScope = this;
      var file = "";
      switch (attachmentName) {
        case "msdsAttachment":
          file = regulatoryInformationScope.msdsAttachment;
          break;
        case "batteryAttachment":
          file = regulatoryInformationScope.batteryAttachment;
          break;
        case "insertAttach":
          file = regulatoryInformationScope.insertAttach;
          break;
      }

      var isUploadValid = /^.*\.(pdf|png|jpg|eps|tiff)$/.test(
        file.name.toLowerCase()
      );
      if (isUploadValid) {
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append(attachmentName, file);

        regulatoryInformationScope.isLoading = true;
        regulatoryInformationScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}uploadItemLevelAttachments?regltryQstnId=${regltryQstnId}`,
            uploadData,
            args
          )
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            regulatoryInformationScope.isLoading = false;
            regulatoryInformationScope.msdsAttachment = null;
            regulatoryInformationScope.batteryAttachment = null;
            regulatoryInformationScope.insertAttach = null;
            regulatoryInformationScope.$buefy.dialog.alert({
              message: `Attachment upload successful.`,
              confirmText: "OK",
              type: "is-success",
              onConfirm: () =>
                regulatoryInformationScope.loadItemRegDetailsUnderSubmission()
            });
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            regulatoryInformationScope.isLoading = false;
            regulatoryInformationScope.$buefy.dialog.alert({
              message: `A problem occurred with the attachment used. Please ensure attachment has the one of the following extensions: pdf, png, jpg, eps, tiff and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger",
              onConfirm: () => {
                switch (attachmentName) {
                  case "msdsAttachment":
                    regulatoryInformationScope.msdsAttachment = null;
                    break;
                  case "batteryAttachment":
                    regulatoryInformationScope.batteryAttachment = null;
                    break;
                  case "insertAttach":
                    regulatoryInformationScope.insertAttach = null;
                    break;
                }
              }
            });
          });
      } else {
        regulatoryInformationScope.$buefy.dialog.alert({
          message: `"${file.name}" - Invalid file type, system accepts only pdf, png, jpg, eps, tiff image types.`,
          confirmText: "OK",
          type: "is-danger",
          onConfirm: () => {
            switch (attachmentName) {
              case "msdsAttachment":
                regulatoryInformationScope.msdsAttachment = null;
                break;
              case "batteryAttachment":
                regulatoryInformationScope.batteryAttachment = null;
                break;
              case "insertAttach":
                regulatoryInformationScope.insertAttach = null;
                break;
            }
          }
        });
      }
    },
    downloadAttachment(regltryQstnId) {
      var regulatoryInformationScope = this;
      regulatoryInformationScope.isLoading = true;
      regulatoryInformationScope
        .$http({
          url: `${process.env.VUE_APP_API_BASE_DOMAIN}downloadRegltryAttachements/regltryQstnId/${regltryQstnId}`,
          method: "GET",
          responseType: "blob"
        })
        .then(function(response) {
          regulatoryInformationScope.isLoading = false;
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            regulatoryInformationScope.submissionIdForRegulatoryInformation +
              "_Regulatory Tab Attachments.zip"
          );
          document.body.appendChild(link);
          link.click();
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          regulatoryInformationScope.isLoading = false;
          regulatoryInformationScope.$buefy.dialog.alert({
            message: `A problem occurred with file download. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    }
  }
};
</script>
<style scoped></style>
